// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulpu2gc{gap:var(--ds-space-100,8px)}._13mh1pd9 [data-smart-element=Title]{font-weight:var(--ds-font-weight-semibold,600)}\n._1bah1yb4{justify-content:space-between}\n._1e0c1txw{display:flex}\n._1wpz1fhb{align-self:stretch}\n._2yhz14q2 [data-smart-element=Title]{color:var(--ds-link,#0c66e4)}\n._4cvresu3{align-items:flex-end}\n._4t3i1k8s{height:1.5rem}\n._4t3i1osq{height:100%}", ""]);
// Exports
module.exports = exports;
